import styled, { css } from "styled-components";
import { DetailDataItemBoxProps } from ".";

const getColor = (props: DetailDataItemBoxProps & { theme: any }) => {
  if (props.contentColor === "primary") {
    return props.theme.colors.primary;
  }
  return props.contentColor || props.theme.colors.contentTxt;
};

export const DetailDataItemBox = styled.div<DetailDataItemBoxProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${(props) =>
    props.route &&
    css`
      span {
        color: ${(props) => props.theme.colors.labelTxt} !important;
      }

      div {
        font-weight: ${() => (props.fontWeight ? props.fontWeight : "600")};
      }
    `}
`;

export const DetailDataLabelSpan = styled.p<any>`
  color: ${(props) => props.theme.colors.contentLabelTxt};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.3rem")};
`;

export const DetailDataContentBox = styled.p<DetailDataItemBoxProps>`
  color: ${(props) => getColor(props)};
  font-size: ${(props) => (props.dateFontSize ? props.dateFontSize : "1.7rem")};
  font-weight: 600;
  font-size: 1.4rem;
  white-space: pre-line;
  word-break: keep-all;
`;
